<template>
    <div v-show="showMask" class="dialog">
        <div v-if="planData" class="dialog-container">
            <div class="bar-navigate">
                <div class="dialog-icon">
                    <div class="o_image o_image_thumbnail"/>
                </div>
                <div class="dialog-title">
                    <span class="text_title">{{ planData.title }}</span>
                </div>
            </div>
            <div class="doc-info">
                <div class="doc-main">
                    <div class="editor_component" style="width:580px;">
                        <CKEditor :text="planData.summary" @text="get_content"></CKEditor>
                    </div>
                </div>
            </div>
            <div class="btns">
                <div class="default-btn" @click="reset()">重置</div>
                <div class="confirm-btn" @click="modify()">保存</div>
                <div class="default-btn" @click="closeBtn">关闭</div>
            </div>
            <div class="close-btn" @click="closeMask"><i class="fa fa-close"></i></div>
        </div>
    </div>
</template>

<script type="text/javascript">
import CKEditor from '@/components/common_components/ckeditor/ckeditor.vue'
import planApi from '@/api/plan/plan_api.js'
import {mapActions, mapState} from 'vuex'

export default {
    props: {
        value: {},
        planData: {
            type: Object,
            require: false
        },
        temp_summary: {
            type: String,
            require: false
        },
        type: {},
    },
    data: function () {
        return {
            showMask: false,
            plan_id: 0,
            content: '',
        }
    },
    components: {
        CKEditor

    },
    computed: {
        ...mapState({})
    },
    watch: {
        value(newVal) {
            this.showMask = newVal;
        },
        showMask(val) {
            this.$emit('input', val);
        },
        planData: function () {
            if (this.planData.summary === '') this.content = this.temp_summary;
            else this.content = this.planData.summary;
            console.log(this.temp_summary)
            this.plan_id = this.planData.id;
        }
    },
    methods: {
        ...mapActions({
            change_warning_message: 'warningBar/change_message',
            change_warning_bar_style_class: 'warningBar/change_warning_bar_style_class'
        }),
        closeMask() {
            this.$emit('close');
            // this.showDialog = false;
        },
        get_content: function (content) {
            this.content = content
        },
        reset() {
            this.planData.summary = this.temp_summary;
        },
        closeBtn() {
            this.$emit('cancel');
            this.closeMask();
        },
        modify: async function () {
            let vals = {
                plan_id: this.plan_id,
                summary: this.content,
            };
            let res = await planApi.modify_plan_summary(vals);
            let data = JSON.parse(res.data.result);
            this.change_warning_message(data.message);
            if (data.code === 'success') {
                this.change_warning_bar_style_class('success');
            } else {
                this.change_warning_bar_style_class('alert');
            }
            this.$emit('updateSummary', this.content);
            this.closeMask();
        },
    },
    mounted() {
        // this.showMask = this.value;
        //this.content = this.planData.summary;
    },
}
</script>
<style scoped>
>>> .ck-content {
    height: 320px !important;
}
</style>
<style lang="scss" scoped>
.dialog {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;

  .dialog-container {
    width: 600px; //800px;
    height: 500px;
    background: #ffffff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 8px;
    position: relative;

    .bar-navigate {
      width: 100%;
      height: 52px;
      border-bottom: solid 1px lightgray;
    }

    .dialog-icon {
      float: left;
      padding: 10px;
      width: fit-content;

      .o_image {
        width: 32px;
        height: 32px;
      }
    }

    .dialog-title {
      width: 80%;
      font-size: 20px;
      color: #696969;
      font-weight: 600;
      padding: 12px 32px 0 54px;
      box-sizing: border-box;
    }

    .doc-info {
      color: #333333;
      padding: 15px;
      box-sizing: border-box;
      height: calc(90% - 60px);

      .doc-subline {

      }

      .doc-main {
        background-color: #eeeeee;
        display: inline-block;
        width: 75%;
        height: 100%;
      }

      .doc-side {
        display: inline-block;
        width: 25%;
        padding-left: 20px;
        position: absolute;
      }
    }

    .inp {
      margin: 10px 0 0 20px;
      width: 200px;
      height: 40px;
      padding-left: 4px;
      border-radius: 4px;
      border: none;
      background: #efefef;
      outline: none;

      &:focus {
        border: 1px solid #509EE3;
      }
    }

    .btns {
      width: 100%;
      height: 60px;
      // line-height: 60px;
      position: absolute;
      bottom: 0;
      left: 0;
      text-align: right;
      padding: 0 16px;
      box-sizing: border-box;

      & > div {
        display: inline-block;
        height: 32px;
        line-height: 32px;
        padding: 0 20px;
        color: #ffffff;
        background: #f1f1f1;
        border-radius: 1px;
        margin-right: 12px;
        cursor: pointer;
      }

      .default-btn {
        color: #787878;

        &:hover {
          color: #509EE3;
        }
      }

      .danger-btn {
        background: #EF8C8C;

        &:hover {
          background: rgb(224, 135, 135);
        }

        &:active {
          background: #EF8C8C;
        }
      }

      .confirm-btn {
        color: #ffffff;
        background: #509EE3;

        &:hover {
          background: #6FB0EB;
        }
      }
    }

    .close-btn {
      position: absolute;
      top: 12px;
      right: 12px;
      width: 30px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 18px;
      cursor: pointer;

      &:hover {
        font-weight: 600;
      }
    }
  }
}

.top-bar {
  position: relative;
  padding: 10px 20px;
  overflow: hidden;
}

[class^="icon-"] {
  background-image: url(/static/img/plan.png?v=6);
  background-image: -webkit-image-set(url(/static/img/plan.png?v=6) 1x, url(/static/img/plan@2x.png?v=6) 2x);
  background-image: image-set(url(/static/img/plan.png?v=6) 1x, url(/static/img/plan@2x.png?v=6) 2x);
  vertical-align: middle;
  display: inline-block;
  background-repeat: no-repeat;
}

.new-main {
  padding-left: 24px;
  overflow: auto;
  z-index: -1 \0
;
}


.new-main table {
  border-collapse: separate;
  border-spacing: 0 16px;
}

.must-fill {
  font-style: normal;
  color: #f00;
}

.new-main table td.even {
  padding-left: 4px;
}

.new-main table td input[type='text'] {
  width: 380px;
  height: 30px;
  border-radius: 3px;
  padding-left: 8px;
  border: 1px solid #d7d8d9;
}

.new-main table td .other-plan {
  margin-left: 13px;
}

.new-main table td .title-tip {
  position: absolute;
}

.remark_r {
  color: #F00;
}

.new-main table .v-top {
  vertical-align: top;
  text-align: right;
}

.new-main table td .mar-top16 {
  margin-top: 16px;
}

.new-main table .v-top span {
  display: inline-block;
}

.new-main table td .plan-content-wrap {
  border: 1px solid transparent;
}

.new-main table td .plan-content {
  position: relative;
  width: 660px;
  padding: 9px;
  background-color: #f8f8f8;
  margin-bottom: 24px;
  transition: border-color .3s;
  border: 1px solid transparent;
  margin-right: 20px;
}

.new-main table td .plan-content input[type='text'] {
  width: 648px;
}

.new-main table td .content-tip {
  line-height: 24px;
  height: 16px;
}

.new-main table td .plan-content .plan-detail-box {
  padding: 10px 0;
  margin: -20px 0;
}

.new-main table td .plan-content .plan-detail {
  position: relative;
  overflow: hidden;
}

.new-main table td .plan-content textarea {
  resize: none;
  width: 596px;
  min-height: 60px;
  padding-right: 20px;
  border-radius: 0;
  border: 1px solid #d7d8d9;
  margin-bottom: 16px;
  overflow: hidden;
}

.icon-remove {
  background-position: -208px -250px;
  height: 16px;
  width: 16px;
}

.icon-remove:hover {
  background-position: -208px -232px;
}

.new-main table td .remove {
  font-size: 18px;
  position: relative;
  text-shadow: none;
  top: 1px;
  margin-left: 1px;
  margin-right: 16px;
  color: #a7bdcd;
  font-style: normal;
  font-family: "Font Awesome 5 Pro";
  font-weight: 900;
}

.new-main table td .sec-remove {
  position: absolute;
  top: 2px;
  right: 10px;
  background-color: transparent;
  margin: 0;
}

.new-main table td .plan-content .add-detail {
  cursor: pointer;
  margin-left: 20px;
  margin-top: 15px;
}

.icon-add-detail {
  font-style: normal;
  width: 9px;
  height: 9px;
  color: #2299ee;
  background-position: -87px -36px;
}


.new-main table td .plan-content i {
  cursor: pointer;
}

.new-main table td .plan-content .add-detail i {
  vertical-align: 0px;
  margin-right: 4px;
}

.text-blue {
  color: #2299ee;
}

.text-gray {
  color: #ccc;
}

.new-main table td .plan-content .add-detail span {
  margin-right: 10px;
}

.new-main table td .add-category {
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: #f8f8f8;
  color: #2299ee;
  cursor: pointer;
  width: 700px;
}

.icon-add-category {
  font-style: normal;
  background-position: -32px -32px;
  width: 18px;
  height: 18px;
}

.new-main table td .add-category i {
  vertical-align: middle \0
;
  margin-right: 8px;
}

.new-main table .v-top {
  vertical-align: top;
  text-align: right;
}

.padding-top-a8 {
  padding-top: 8px;
}

.new-main table td .plan-conclusion {
  width: 689px;
  resize: none;
  border-radius: initial;
}

.btn-group {
  position: relative;
  display: inline-block;
  *display: inline;
  *zoom: 1;
  vertical-align: middle;
  white-space: nowrap;
  *margin-left: .3em;
}

.new-main table td .btn-group button {
  height: 30px;
  margin-right: 10px;
  border-style: none;
  font-size: 12px;
  border-radius: 3px
}

.new-main table td .btn-group button.release {
  width: 120px;
  background-color: #2299ee;
  color: #fff;
}

.new-main table td .btn-group button.cancel {
  width: 90px;
  background-color: #fff;
  border: 1px solid #d7d8d9;
  color: #000;
}

.mask-span {
  width: 120px;
  display: inline-block;

  height: 26px;
  padding: 0 0;
  line-height: 26px;
  padding-left: 10px;
  background-color: transparent;
  border: 1px solid #d7d8d9;
  border-radius: 0;
  color: #666;
  cursor: pointer;
  margin-right: 10px;
  margin-left: 0;
  position: relative;
  z-index: 19;
}

.mask-span.week {
  width: 160px;
}

#week-plan, #month-plan, #quarter-plan {
  line-height: 24px;
  display: inline-block;
  vertical-align: middle;
}

.icon-triangle-up, .icon-triangle-right, .icon-triangle-down, .icon-triangle-left {
  background-image: none;
  width: 0;
  height: 0;
  cursor: pointer;
}

.icon-triangle-down {
  border-left: 5px solid transparent;
  border-top: 5px solid #9a9a9a;
  border-right: 5px solid transparent;
  vertical-align: middle;
  display: inline-block;
}

* {
  margin: 0;
  padding: 0;
  list-style: none;

}

.head {
  padding: 20px;
}

.navBar input {
  width: 215px;
  height: 38px;
  display: inline-block;
}

.show1 {
  width: 320px;
  margin-top: 5px;
  position: absolute;
  z-index: 2;

  height: 160px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  background: #fff;
  padding: 5px;
}

.show1 p:nth-child(1) {
  width: 100%;
  height: 40px;
  border-bottom: 1px solid #f5f5f5;
}

.show1 p:nth-child(2) {
  box-sizing: border-box;
}

.selectMonth {
  display: inline-block;
  float: left;
  width: 78px;
  height: 40px;
  line-height: 40px;
  text-align: center;
}

.selectMonth:hover {
  background: rgba(19, 131, 255, 0.052);
}

.span-year {
  width: 90%;
  margin: 0 auto;
  display: inline-block;
  text-align: center;
  line-height: 40px;

}

.el-input {
  width: 215px;
  height: 38px;
  display: inline-block;
}

.new-main table td .other-plan {
  margin-left: 13px;
  font-size: 12px;
}

.new-main table td .other-plan a.look-prev {
  border-right: 1px solid #d9d9d9;
  display: inline-block;
  line-height: 12px;
  padding-right: 8px;
  margin-right: 7px;
}

.new-main table td .other-plan a {
  color: #29e;
}

.mainright {
  margin-right: 522px
}
</style>
